import Modal from 'components/Modal'
import IcashDonationRefundTx from 'views/MemberProfile/ManualTx/IcashDonationRefundTx'

type Props = {
  title: string | undefined
  open: boolean
  onClose: () => void
}

const ModalIcashDonationRefundTx = ({
  title,
  open,
  onClose,
}: Props): JSX.Element => {
  return (
    <Modal open={open} title={title} onClose={onClose} noFooter>
      <IcashDonationRefundTx onClose={onClose} />
    </Modal>
  )
}

export default ModalIcashDonationRefundTx
